import React from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { QUARTER_HOURS_COUNTS } from '@redux/session/types';
import { useSelector } from 'react-redux';

import { ProlongationHandler } from './ProlongationHandler';
import { ProlongationHandlerContainerWrapper } from './ProlongationHandlerContainer.style';

export const prolongationQuarterHourCounts = [
  QUARTER_HOURS_COUNTS.TWO_HOURS,
  QUARTER_HOURS_COUNTS.ONE_HOUR,
  QUARTER_HOURS_COUNTS.THIRTY_MINUTES,
];

export const ProlongationHandlerContainer: React.FC<{
  handleExtensionSuccess: (newEndTime: number) => void;
}> = ({ handleExtensionSuccess }) => {
  const colors = useSelector(colorsSelector);

  return (
    <ProlongationHandlerContainerWrapper colors={colors}>
      <ProlongationHandler onSuccess={handleExtensionSuccess} />
    </ProlongationHandlerContainerWrapper>
  );
};
